import { HttpClient } from '@angular/common/http';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { ModuleTipuriProgramActiveService } from './module-tipuri-program-active.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { AddModuleTipuriProgramActiveComponent } from './add-module-tipuri-program-active/add-module-tipuri-program-active.component';
import Swal from 'sweetalert2';
import { IModulTipProgramActiv } from './module-tipuri-program-active.interface';
import { EditModuleTipuriProgramActiveComponent } from './edit-module-tipuri-program-active/edit-module-tipuri-program-active.component';


@Component({
    selector: 'app-module-tipuri-program-active',
    templateUrl: './module-tipuri-program-active.component.html',
    styleUrls: ['./module-tipuri-program-active.component.scss']
})
export class ModuleTipuriProgramActiveComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;

    helper = helper;
    isLoading = false;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    dtLink =
        environment.interop.basePath +
        environment.interop.deps.nomenclatoare.moduleTipProgramActiv.listDT;

    constructor(
        private dialogService: DialogService,
        private http: HttpClient,
        private dialog: MatDialog,
        private moduleTipuriProgramActiveService: ModuleTipuriProgramActiveService,
        public permissionsService: PermissionsService,
    ) { }

    ngOnInit(): void {
        this.renderDT();
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            responsive: true,
            pageLength: 25,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id',
                },
                {
                    title: 'Modul',
                    data: 'modul_name',
                    orderable: false,
                },
                {
                    title: 'Tip program',
                    data: 'program_type_name',
                    orderable: false,
                },
                {
                    title: 'Acțiuni',
                    data: null,
                    className: 'all',
                    orderable: false,
                    render: (data: any, type: any, row: any, met: any) => {
                        return (
                            `
                            <div class="d-flex align-center justify-content-left">
                            <button class="action-btn edit" title="Editează">
                                <img class="btn-img" src="/assets/icons/edit.svg" alt="edit"/>
                            </button>
                            <button type="button" class="action-btn delete ms-1" title="Șterge">
                                <img class="btn-img" src="/assets/icons/delete.svg" alt="delete"/>
                            </button>
                            </div>
                            `
                        );
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const editIcon = lastTd?.querySelector('.edit') as HTMLElement;
                const deleteIcon = lastTd?.querySelector('.delete') as HTMLElement;

                if (editIcon) {
                    if (!this.permissionsService.hasPermission('deps-module.settings.module-tipuri-program.update')) {
                        editIcon.style.display = 'none';
                    }
                    editIcon.addEventListener('click', () => {
                        this.openEditDialog(data);
                    });
                }

                if (deleteIcon) {
                    if (!this.permissionsService.hasPermission('deps-module.settings.module-tipuri-program.delete')) {
                        deleteIcon.style.display = 'none';
                    }
                    deleteIcon.addEventListener('click', () => {
                        const { id } = data;
                        this.deleteModulTipProgramActiv(id);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(resetPaging = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(resetPaging);
        });
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddModuleTipuriProgramActiveComponent, {
            ...this.dialogService.getDialogConfig(),
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul tip program adăugat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    openEditDialog(data: IModulTipProgramActiv) {
        const dialogRef = this.dialog.open(EditModuleTipuriProgramActiveComponent, {
            ...this.dialogService.getDialogConfig(),
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.isLoading = true;
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul tip program actualizat cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            }
        });
    }

    deleteModulTipProgramActiv(id: number) {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Nu o să puteți recupera datele odată cu ștergerea lor!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // we do this because we need to have some control on activity
                this.deleteModulTipProgramActivAction(id);
            }
        });
    }

    deleteModulTipProgramActivAction(id: number) {
        this.isLoading = true;
        this.moduleTipuriProgramActiveService.deleteModulTipProgramActiv(id).subscribe(
            () => {
                this.rerenderDT();
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Modul tip program șters cu succes.',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                });
            },
            (err) => {
                this.isLoading = false;
                let msg;
                try {
                    // try to catch the message from server
                    msg = err.error.errors.message[0];
                } catch (error) {
                    // controll output message
                    msg = helper.dialogConfig.generalMessages.error;
                }

                Swal.fire({
                    title: helper.dialogConfig.headers.errorAtentie,
                    text: msg,
                    icon: 'error',
                    confirmButtonText: helper.dialogConfig.buttonLabels.retry,
                    showCancelButton: true,
                    cancelButtonText: helper.dialogConfig.buttonLabels.close,
                    reverseButtons: true,
                    allowOutsideClick: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deleteModulTipProgramActivAction(id);
                    }
                });
            }
        );
    }
}
